module.exports = __webpack_public_path__ + "static/cabina-conductor---cupula-8fd98e6d72487f6ec0d9e9b46cbed136.jpg";